export const API_KEY = 'f59753c2d71820541bb691c8a7759421';
export const BASE_API_URL = 'https://api.themoviedb.org/3';
export const SEARCH_API = `${BASE_API_URL}/search/movie?&api_key=${API_KEY}&query=`;
export const IMG_URL = 'https://image.tmdb.org/t/p/w1280';
export const DEFAULT_IMG_POSTER =
  'https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2059&q=80';
